import { toIsoString } from "features/common/lib/date";
import authorizedCall from "features/common/utils/authorizedCall";
import { downloadPDF } from "features/common/utils/downloadPdf";
import { ExportResponse, WbhExportControllerService } from "openapi";
import { useState } from "react";

export interface useExportClientsModalArgs {
  idList: number[];
  taskNr: string;
  onClose: () => void;
}

export const useExportClientModal = ({
  idList,
  taskNr,
  onClose,
}: useExportClientsModalArgs) => {
  const [isExportCompleted, setIsExportCompleted] = useState(false);
  const [isExecutingExport, setIsExecutingExport] = useState(false);
  const [exportError, setExportError] = useState("");
  const [downloadSuccess, setDownloadSuccess] = useState<undefined | boolean>();
  const [isDownloadingReport, setIsDownloadingReport] = useState(false);
  const [downloadReportError, setDownloadReportError] = useState("");
  const [reportId, setReportId] = useState("");

  const canExport = idList.length > 0 && !!taskNr;

  const handleClose = () => {
    onClose();
    setExportError("");
    setIsExportCompleted(false);
  };

  const handleExport = () => {
    setReportId("");
    setIsExecutingExport(true);
    /*authorizedCall(ClientControllerService.getAllClients, {
      idList,
      number: taskNr,
      fileTimestamp: toIsoString(new Date()),
    })*/
    authorizedCall(
      WbhExportControllerService.createExport,
      {
        requestBody: {
          idList,
          taskNumber: taskNr,
          timestamp: toIsoString(new Date()),
          type: "CLIENT",
        },
      },
      true
    )
      .then((response: ExportResponse) => {
        setIsExecutingExport(false);
        setIsExportCompleted(true);

        const filename = response.filename;

        setReportId(filename);

        setIsDownloadingReport(true);
        downloadPDF(filename)
          //downloadPDF(idList, taskNr, toIsoString(new Date()), "test")
          .then(() => {
            setIsDownloadingReport(false);
            setDownloadSuccess(true);
          })
          .catch((error) => {
            setIsDownloadingReport(false);
            setDownloadSuccess(false);
            setDownloadReportError(error?.body?.message || error?.message);
          });
      })
      .catch((error) => {
        setIsExecutingExport(false);

        if (error.status === 504) {
          setExportError(
            "Process is taking more time than expected. Please check export log after few minutes."
          );
        } else {
          setExportError(error?.body?.message || error?.message);
        }
      });
  };

  return {
    canExport,
    handleClose,
    handleExport,
    isExecutingExport,
    exportError,
    isExportCompleted,
    downloadSuccess,
    isDownloadingReport,
    downloadReportError,
    reportId,
  };
};
